import axios from 'axios'
import {
    GET_LIST_BANK_REQUEST,
    GET_LIST_BANK_SUCCESS,
    GET_LIST_BANK_FAILED
} from '../../actionTypes'

export const listBankRequest = () => {
    return {
      type: GET_LIST_BANK_REQUEST,
    };
  };
  
  export const listBankSuccess = (value) => {
    return {
      type: GET_LIST_BANK_SUCCESS,
      payload: value,
    };
  };
  
  export const listBankFailed = (value) => {
    return {
      type: GET_LIST_BANK_FAILED,
      error: value,
    };
  };

  export const getListBank = () => (dispatch) => {
    //   event.preventDefault();
      // console.log("register value");
    
      const URI = `deposit-list/bank`;
    
      return axios
        .get(URI)
        .then((response) => {
          console.log("getBistBank response", response);
          dispatch(listBankSuccess(response.data));
        })
        .catch((error) => {
          console.log(error);
        });
    };